
import $ from "jquery"
import _extend from "lodash/assign"


const INIT_COMPLETE_CLASS = "js-photoswipe-init-done"

interface Selector {
  carousel: string
  image:    string
}
interface InputSelector {
  carousel?: string
  image?:    string
}
const default_selector = {
  carousel: ".carousel",
  image:    "img",
}

class FloorPlanImagesCarouselSwipe {
  private selector: Selector
  private $container_el: JQuery
  private $carousel: JQuery
  private $image: JQuery

  constructor({container_element, selector = {}}: {container_element: Element | string | JQuery, selector: InputSelector}) {
    if (container_element == null) {
      throw new Error("container_element is absent")
    }

    this.selector = _extend({}, default_selector, selector)
    this.$container_el = $(container_element)

    this.$carousel  = this.$container_el.find(this.selector.carousel)
    this.$image     = this.$container_el.find(this.selector.image)

    this.bind_action()
  }
  private bind_action(){
    if (this.$carousel.hasClass(INIT_COMPLETE_CLASS)) { return this }
    this.$carousel.addClass(INIT_COMPLETE_CLASS)

    const slide_data_objects = [] as PhotoSwipe.Item[]
    this.$image.each((_idx, img_element) => {
      const $img_element  = $(img_element)
      const image_width   = $img_element.data("photoswipe-width")
      const image_height  = $img_element.data("photoswipe-height")
      const image_src     = $img_element.data("photoswipe-src")
      // Optional
      const image_msrc    = $img_element.data("photoswipe-msrc")

      if ([image_width, image_height, image_src].some((e) => e == null)) {
        return
      }

      slide_data_objects.push({
        src:  image_src,
        w:    image_width,
        h:    image_height,

        // Optional
        msrc: image_msrc,
      })
    })

    if (document.querySelectorAll(".pswp")[0] == null) {
      // Minified from source code provided by photoswipe
      // https://photoswipe.com/documentation/getting-started.html
      $("body").append("<div class=\"pswp\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"pswp__bg\"></div><div class=\"pswp__scroll-wrap\"><div class=\"pswp__container\"><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div></div><div class=\"pswp__ui pswp__ui--hidden\"><div class=\"pswp__top-bar\"><div class=\"pswp__counter\"></div><button class=\"pswp__button pswp__button--close\" title=\"Close (Esc)\"></button><button class=\"pswp__button pswp__button--share\" title=\"Share\"></button><button class=\"pswp__button pswp__button--fs\" title=\"Toggle fullscreen\"></button><button class=\"pswp__button pswp__button--zoom\" title=\"Zoom in/out\"></button><div class=\"pswp__preloader\"><div class=\"pswp__preloader__icn\"><div class=\"pswp__preloader__cut\"><div class=\"pswp__preloader__donut\"></div></div></div></div></div><div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=\"pswp__share-tooltip\"></div></div><button class=\"pswp__button pswp__button--arrow--left\" title=\"Previous (arrow left)\"> </button><button class=\"pswp__button pswp__button--arrow--right\" title=\"Next (arrow right)\"> </button><div class=\"pswp__caption\"><div class=\"pswp__caption__center\"></div></div></div></div></div>")
    }


    if (slide_data_objects.length > 0) {
      import(
        "photoswipe/dist/photoswipe-ui-default"
      )
      .then(({default: PhotoSwipeUI_Default}) => {
        import(
          "photoswipe"
        )
        .then(({default: PhotoSwipe}) => {
          this.$image.on("click", () => {
            const gallery = new PhotoSwipe(
              document.querySelectorAll(".pswp")[0] as HTMLElement,
              PhotoSwipeUI_Default,
              slide_data_objects,
              {
                // Don't change history when browsing gallery
                history: false,

                bgOpacity: 0.8,

                shareEl:      false,
                fullscreenEl: false,
                captionEl:    false,

                clickToCloseNonZoomable:  false,
                tapToClose:               true,
              },
            )
            gallery.init()
          })
        })
      })
    }

    return this
  }
}

const Factory = {
  create(container_element: Element | string | JQuery, selector?: InputSelector){
    return new FloorPlanImagesCarouselSwipe({container_element: container_element, selector: (selector || {})})
  },
}

export { Factory as default }
